/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SaveClientAssignedPermission$Params {
      body?: {
'clientID'?: number;
'permissionID'?: number;
'userIDs'?: Array<number>;
'userTypeIDs'?: Array<number>;
}
}

export function SaveClientAssignedPermission(http: HttpClient, rootUrl: string, params?: SaveClientAssignedPermission$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, SaveClientAssignedPermission.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

SaveClientAssignedPermission.PATH = '/api/Permissions/SaveClientAssignedPermission';
